//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	//#endregion

	//#region Style vars
	let workoutContainerHeight = '25rem';
	let workoutItemHeight = '100%';
	let subtitleMarginTop = '0.25rem';
	let buttonMarginTop = '1rem';
	let learnMoreMarginTop = '1rem';
	//#endregion

	//#region seting vars based off params
	if (isMobile) {
		workoutContainerHeight = 'auto';
		workoutItemHeight = '40rem';
		subtitleMarginTop = '.5rem';
		buttonMarginTop = '1rem';
		learnMoreMarginTop = '1rem';
	}
	//#endregion

	return {
		displayOuterContainer: ({mt} = {}) => {
			return {
				display: 'flex',
				width: '100%',
				height: workoutContainerHeight,
				flexWrap: 'wrap',
				backgroundColor: 'black',
				marginTop: mt ? '3rem' : 'unset',
			};
		},
		workoutItem: bg => {
			return {
				display: 'flex',
				flexDirection: 'column',
				height: workoutItemHeight,
				padding: 0,
				backgroundImage: `url(${bg})`,
				objectFit: 'cover',
				backgroundSize: 'cover',
				padding: '0.5%',
				border: 0,
			};
		},
		workoutContentsContainer: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				width: 'auto',
				height: 'auto',
				margin: 'auto',
				maxWidth: '100%',
			};
		},
		titleText: () => {
			return {
				textAlign: 'center',
				fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
				'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
				sans-serif`,
			};
		},
		subtitleText: () => {
			return {
				color: 'white',
				overflowWrap: 'anywhere',
				textDecoration: 'none',
				textAlign: 'center',
				marginTop: subtitleMarginTop,
			};
		},
		buttonText: () => {
			return {
				margin: `${buttonMarginTop} auto 0 auto`,
				color: 'white',
				fontSize: '1rem',
				overflowWrap: 'anywhere',
				textDecoration: 'none',
				textAlign: 'center',
				padding: '0.25rem',
				border: '2px solid white',
				borderRadius: '10px',
				width: '6rem',
			};
		},
		learnMoreText: () => {
			return {
				margin: `${learnMoreMarginTop} 0 0 0`,
				color: 'white',
				fontSize: '1rem',
				overflowWrap: 'anywhere',
				textAlign: 'center',
			};
		},
	};
}

export default Styles;
